import React from 'react'

import type { CompanyPosition } from '../../../../api/companies/types'
import { OuterTabGroup } from '../../../components/form/tab-groups'
import PositionInfo from './Info'

type Props = {
  positions?: CompanyPosition[],
  companyId: number,
  divisionId: number,
}
const PositionsTabs:React.FC<Props> = ({ companyId, divisionId, positions }) => {
  const [activePositionName, setActivePositionName] = React.useState<string>(positions?.[0].name || '')
  if(!positions) { return <div /> }

  const tabs = positions.map((position) => ({ id: position.name, title: position.name }))
  const activePosition = positions.find(pos => pos.name === activePositionName)
  if(!activePosition) return null
  return (
    <>
      <OuterTabGroup
        handleClick={setActivePositionName}
        active={activePositionName}
        tabs={tabs}
      />
      <PositionInfo companyId={companyId} divisionId={divisionId} subDivisionId={activePosition.subDivisionId} position={activePosition} />
    </>
  )
}

export default PositionsTabs
